import React from 'react';
import styled from 'styled-components';
import he from 'he';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
`;

const Modal = styled.div`
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  width: 600px;
  text-align: left;
  max-height: 80vh;
  overflow-y: auto;
  word-wrap: break-word;
`;

const Button = styled.button`
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
  }
`;

interface AlertModalProps {
  message: string;
  onClose: () => void;
}

const extractValues = (rawText: string) => {
  const decoded = he.decode(rawText);

  const getAttr = (el: Element | null, attr: string) =>
    el?.getAttribute(attr)?.trim() || "-";

  const getText = (parent: Element | null, tag: string) =>
    parent?.querySelector(tag)?.textContent?.trim() || "-";

  // CASE 1: Original <transacciones> format
  if (decoded.includes("<transacciones")) {
    const match = decoded.match(/<transacciones[\s\S]*<\/transacciones>/);
    if (!match) return null;

    const xmlDoc = new DOMParser().parseFromString(match[0], "text/xml");

    const transaccion = xmlDoc.querySelector("transaccion");
    const vehiculo = xmlDoc.querySelector("vehiculo");
    const poliza = xmlDoc.querySelector("poliza");
    const prima = xmlDoc.querySelector("prima");

    return {
      cotizacion: getAttr(transaccion, "cotizacion"),
      NoPoliza: getAttr(transaccion, "NoPoliza"),
      emision: getAttr(transaccion, "emision"),
      amis: getAttr(vehiculo, "amis"),
      modelo: getAttr(vehiculo, "modelo"),
      descripcion: getAttr(vehiculo, "descripcion"),
      placas: getAttr(vehiculo, "placas"),
      "poliza id": getAttr(poliza, "id"),
      fecemision: getAttr(poliza, "fecemision"),
      feciniciovig: getAttr(poliza, "feciniciovig"),
      fecterminovig: getAttr(poliza, "fecterminovig"),
      primaneta: getAttr(prima, "primaneta"),
      impuesto: getAttr(prima, "impuesto"),
      primatotal: getAttr(prima, "primatotal"),
    };
  }

  // CASE 2: New <Movimientos> format
  if (decoded.includes("<Movimientos")) {
    const match = decoded.match(/<Movimientos[\s\S]*<\/Movimientos>/);
    if (!match) return null;

    const xmlDoc = new DOMParser().parseFromString(match[0], "text/xml");

    const movimiento = xmlDoc.querySelector("Movimiento");
    const vehiculo = xmlDoc.querySelector("DatosVehiculo");
const poliza = xmlDoc.querySelector("poliza");
    const generales = xmlDoc.querySelector("DatosGenerales");
    const primas = xmlDoc.querySelector("Primas");

    return {
      cotizacion: getAttr(movimiento, "NoCotizacion"),
      NoPoliza: getAttr(movimiento, "poliza id"),
      amis: getText(vehiculo, "ClaveAmis"),
      modelo: getText(vehiculo, "Modelo"),
      descripcion: getText(vehiculo, "DescripcionVehiculo"),
      placas: getAttr(vehiculo, "placas"),
"poliza id": getAttr(poliza, "id"),
      fecemision: getText(generales, "FechaEmision"),
      feciniciovig: getText(generales, "FechaInicio"),
      fecterminovig: getText(generales, "FechaTermino"),
      primaneta: getText(primas, "PrimaNeta"),
      impuesto: getText(primas, "Impuesto"),
      primatotal: getText(primas, "PrimaTotal"),
    };
  }

  return null;
};

const AlertModal: React.FC<AlertModalProps> = ({ message, onClose }) => {
  const data = extractValues(message);

  return (
    <ModalOverlay>
      <Modal>
        <h3>Detalles de la Cotización o Emisión</h3>
        {data ? (
          <table>
            <tbody>
              {Object.entries(data).map(([key, value]) => (
                <tr key={key}>
                  <td><strong>{key.charAt(0).toUpperCase() + key.slice(1)}</strong></td>
                  <td>{value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No se encontraron datos válidos.</p>
        )}
        <Button onClick={onClose}>Cerrar</Button>
      </Modal>
    </ModalOverlay>
  );
};

export default AlertModal;
